/*********************************************************************************************
* Splide Collection
    *
*/
document.addEventListener('DOMContentLoaded', function() {
    var splideSections = document.querySelectorAll('[data-section-hero-collection-id]');

    splideSections.forEach(function(section) {
        var splideElem = section.querySelector('.splide-hero-collection-collection');

        if (!splideElem) return;

        var splide = new Splide(splideElem, {
            type: 'slide',
            arrows: true,
            pagination: false,
            perPage: 1,
            drag: 'free',
            snap: true,
            perMove: 1,
            omitEnd: true,
            gap: '10px',
            breakpoints: {
                768: {},
            },
        });

        splide.mount();
    });
});
